import React, { useState, useEffect } from "react";
import { FaAngleLeft } from "react-icons/fa";
import "react-calendar/dist/Calendar.css";
import ErrorMessagesPagos from "../../Assets/ErrorMessagesFactura.json";
import { useMediaQuery } from "react-responsive";
import "../../index.css";
import { FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";
import { RiInstagramFill, RiEmotionSadLine } from "react-icons/ri";
import { BsCheck2Circle } from "react-icons/bs";

import { Link, useSearchParams } from "react-router-dom";
import Modal from "../../Components/elements/modals/Modal";
import styled from "styled-components";
import { currencyPipe } from "../../Utils/pipes";
import {
  getRequest,
  loadSessionUser,
  postRequest,
} from "../../Services/axios.service";
import { FACTURA, SERVICE_CLIENT } from "../../Utils/url.api";
import moment from "moment";
import StarRatings from "react-star-ratings";
import useUser from "../../Context/hook/useUser";
import Box from "@mui/material/Box";
import MaterialModal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store/ui";

function Factura() {
  const dispatch = useDispatch();
  const isPhonePortOrMinor = useMediaQuery({
    query: "(max-width: 56.25em)",
  });

  const [open, setOpen] = useState(false);
  const { getUser } = useUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const [facturaId, setFacturaId] = useState(searchParams.get("facturaId"));
  const [responseCode, setResponseCode] = useState(
    searchParams.get("responseCode")
  );
  const [message, setMessage] = useState(searchParams.get("message"));
  const [cas, setCas] = useState(null);
  const [factura, setFactura] = useState(null);
  const [calificacion, setCalificacion] = useState(0);
  const [openCas, setOpenCas] = useState(false);

  useEffect(() => {
    getParams();
  }, []);

  const getParams = () => {
    const currentResponseCode = searchParams.get("responseCode");
    setResponseCode((current) => currentResponseCode);
    setOpen(true);
    fetchFactura();
    setOpenCas(false);
  };

  const fetchFactura = async () => {
    console.log("running");
    dispatch(uiActions.ladingStatus({ conditional: true }));
    const { data } = await getRequest(`${FACTURA}/${facturaId}`);

    if (data?.statusCode === 200) {
      dispatch(uiActions.ladingStatus({ conditional: false }));
      setFactura((current) => data.data);
    }
  };

  const postRating = async () => {
    const clientId = getUser().id;
    const model = {
      
      serviceId: 1,
      clientId,
      cas: factura.cas,
      //rating: calificacion,
    };
   
    const headers = {
      Authorization: `Bearer ${loadSessionUser()}`,
    };
    const { data } = await postRequest(SERVICE_CLIENT, model, { headers });
    
    if (data.statusCode == 201) {
      setCas(data.data?.cas);
      setOpen(false);
      setOpenCas(true);
    }
  };

  const ReviewModal = () => (
    <Modal estado={open} cambiarEstado={setOpen}>
      <Contenido>
        <h1 className="text-primary-dark text-center text-3xl font-bold pb-2.5 py-8">
          Ayúdanos a mejorar
        </h1>
        <p className="text-2xl p-4 ">
          Es el momento perfecto para dejarnos tu valoración
          <br />
          <br />
          Califique la experiencia obtuvo utilizando nuestros servicios en línea
          y ayúdanos a seguir mejorando.
        </p>
        <div className="flex flex-col items-center justify-center">
          <StarRatings
            rating={calificacion}
            starRatedColor="gold"
            starHoverColor="goldenrod"
            changeRating={(e) => setCalificacion((cur) => e)}
            numberOfStars={5}
            name="rating"
          />

          <div className="Contenedor-boton block">
            <button
              onClick={postRating}
              className="py-6 px-32 text-4xl bg-[#003670] text-white rounded-lg"
            >
              Enviar
            </button>
          </div>
        </div>
        <div className="footer__trademark-social text-primary-dark p-20 text-2xl ">
          <span>SÍGUENOS</span>
          <ul className="footer__trademark-social-list">
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.facebook.com/AmbienteRD/">
                  <FaFacebookF />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://twitter.com/ambienterd">
                  <FaTwitter />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.instagram.com/ambienterd/">
                  <RiInstagramFill />
                </a>
              </i>
            </li>
            <li className="footer__trademark-social-item">
              <i>
                <a href="https://www.youtube.com/c/ministerioambienterd">
                  <FaYoutube />
                </a>
              </i>
            </li>
          </ul>
        </div>
      </Contenido>
    </Modal>
  );

  const CasModal = () => (
    <MaterialModal
      open={openCas}
      onClose={() => setOpenCas(false)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box sx={isPhonePortOrMinor ? boxStyleResp : boxStyle}>
        <h2
          id="parent-modal-title"
          className="text-primary font-semibold text-4xl"
        >
          ¡Transacción completada con exito!
        </h2>
        <p
          id="parent-modal-description"
          className="text-dark font-medium text-2xl"
        >
          Tu código de Adquisición de servicio {"(cas): " + cas}
        </p>
      </Box>
    </MaterialModal>
  );

  return (
    <div className="py-40 mx-8">
      {factura && (
        <div className="flex items-center">
          <Link to="/">
            <FaAngleLeft className="icono" />
          </Link>
          <h1 className="ml-10 text-5xl font-medium inline-block">
            Ver Factura
          </h1>
        </div>
      )}
      <>
        {getUser() !== null && factura && <ReviewModal />}
        <CasModal />
        {factura && (
          <div className="flex tab-port:justify-around flex-col-reverse tab-port:flex-row tab-port:gap-x-4 gap-y-16 mt-4 tab-port:mt-8">
            {true && (
              <div className="border rounded-2xl border-bd-light border-solid basis-auto tab-land:basis-5/12 small-desktop:basis-4/12">
                <div className="carbonads p-10 mx-auto my-8">
                  <div className="flex flex-col justify-center items-center phone:flex-row ">
                    <div className="">
                      <img
                        src={factura?.imagenParque}
                        alt={factura?.nombreParque}
                        className="max-w-[20rem] phone:max-w-[150px]"
                      />
                    </div>
                    <div className="mx-[3rem] mt-6 tab-port:mt-2">
                      <p className="text-2xl font-bold pb-2.5">
                        {factura?.nombreParque}
                      </p>
                      <p className="text-base">{factura?.description3}</p>
                    </div>
                  </div>
                </div>
                <div className="dividir"></div>
                <div className="mx-12 mb-20 phone:mb-30">
                  <p className="text-4xl font-semibold font-sans">Factura</p>
                  {factura?.facturaDetalles?.map((item, i) => (
                    <div key={i}>
                      <p className="mt-11 text-2xl">
                        {moment(item.fechaValid)
                          .locale("es")
                          .format("DD MMM, YYYY")}
                      </p>
                      <div className="flex justify-between items-center gap-y-2 my-2 flex-row">
                        <p className="text-3xl">
                          <span>
                            ${currencyPipe(item.precioUnitario)} x{" "}
                            {item.cantidad} Tickets
                          </span>
                        </p>
                        <p className="text-3xl">
                          <span>${currencyPipe(item.total)}</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="dividir"></div>
                <div className="mx-12 mb-12">
                  <div className="flex justify-between gap-y-6 flex-col phone:flex-row">
                    <p className="text-3xl font-semibold">{"Total (RDS)"}</p>
                    <p className="text-3xl">
                      <span>${factura?.totalFactura}</span>
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className=" border border-bd-light rounded-2xl border-solid basis-auto tab-land:basis-7/12 small-desktop:basis-7/12 p-10">
              <div className="grid grid-rows-1">
                <div className="carbonads mx-auto my-4">
                  <div className="flex flex-col phone:flex-row justify-start items-start">
                    <div className="mt-6 tab-port:mt-2 py-6">
                      <div className="flex justify-center">
                        {/* <BsAlignCenter className="text-[10rem] text-success mb-10"></BsAlignCenter> */}
                      </div>

                      {ErrorMessagesPagos.map((ErrorMessages) => {
                        if (
                          responseCode === "00" &&
                          responseCode === ErrorMessages.code
                        ) {
                          return (
                            <>
                              <div className="flex justify-center">
                                <BsCheck2Circle className="text-[10rem] text-success mb-10"></BsCheck2Circle>
                              </div>
                              <p className="text-center title-qr text-5xl mb-6">
                                ¡Pago realizado con éxito!
                              </p>
                              <p className="text-baseQr text-3xl tab-port:w-[40vw] text-justify">
                                Recibirás un correo electrónico con el código QR
                                respectivo. El código te llegará al correo que
                                hayas registrado y te servirá para recibir los
                                tickets comprados para dicho parque.
                              </p>
                              <div className="divider"></div>
                              <div className="flex mt-10 text-center tab-port:text-left tab-port:flex-row flex-col justify-between w-[80vw] tab-port:w-[40vw] mx-auto  border-solid border-2 rounded-2xl">
                                <div className="p-4">
                                  {factura?.facturaDetalles?.map((item, i) => (
                                    <div className="my-4">
                                      <p className="text-3xl mb-2 font-bold font-sans">
                                        E-ticket válido para
                                      </p>
                                      <p className="text-3xl font-sans">
                                        {" " + item?.descripcion.split(":")[1]}
                                      </p>
                                      <p className="mt-4 text-3xl font-bold font-sans">
                                        Para la fecha:
                                      </p>
                                      <p className="mt-4 text-3xl font-sans">
                                        <span className="mt-4 text-3xl font-sans  pb-2.5">
                                          {" "}
                                          {moment(item.fechaValid)
                                            .locale("es")
                                            .format("DD/MM/YYYY")}
                                        </span>
                                      </p>
                                    </div>
                                  ))}
                                </div>
                                <img
                                  className="tab-port:w-64 tab-port:h-64 w-96 h-96 tab-port:mt-auto tab-port:mx-0 mx-auto"
                                  src={factura?.codigoQR}
                                  alt=""
                                />
                              </div>
                            </>
                          );
                        } else if (
                          responseCode !== "00" &&
                          responseCode === ErrorMessages.code
                        ) {
                          return (
                            <>
                              <div className="flex justify-center">
                                <RiEmotionSadLine className="text-[10rem] text-success mb-10"></RiEmotionSadLine>
                              </div>
                              <p className="text-center text-xl mb-6">
                                Ha ocurrido un error en la transacción
                              </p>
                              <p className="text-center title-qr text-5xl mb-2">
                                {message ?? ErrorMessages.message}
                              </p>
                            </>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    </div>
  );
}

export default Factura;

const Contenido = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const boxStyleResp = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
